export default function RetentionSettingsController(
  $scope,
  $stateParams,
  retentionSettingsService,
  NotificationService,
  RETENTION_LENGTH_OPTIONS,
) {
  var vm = this;

  vm.merchantId = $stateParams.merchantId;
  vm.isLoading = false;
  vm.retentionSettings = [];
  vm.retentionLengthOptions = RETENTION_LENGTH_OPTIONS;

  vm.init = init;
  vm.updateRetentionSettings = updateRetentionSettings;

  var listener = $scope.$on('merchant.tab.retention.selected', vm.init);
  $scope.$on('merchant.objects.updated', getRetentionSettings);
  $scope.$on('merchant.combinations.updated', getRetentionSettings);

  function init() {
    listener();
    getRetentionSettings();
  }

  function getRetentionSettings() {
    enableLoading();
    retentionSettingsService
      .getRetentionSettings(vm.merchantId)
      .then(initRetentionSettings)
      .catch(function() {
        NotificationService.error('Error getting retention settings');
      })
      .finally(disableLoading);
  }

  function initRetentionSettings(res) {
    vm.retentionSettings = res.data.settings.map(function(retentionSetting) {
      retentionSetting.value = parseInt(retentionSetting.value, 10);
      retentionSetting.minValue = parseInt(retentionSetting.minValue, 10);
      return retentionSetting;
    });
  }

  function updateRetentionSettings() {
    var invalidData = false;
    if (vm.isLoading) {
      return;
    }
    angular.forEach(vm.retentionSettings, function(retentionSetting) {
      if (retentionSetting.minValue > retentionSetting.value) {
        invalidData = true;
      }
    });
    if (invalidData) {
      return;
    }
    enableLoading();
    retentionSettingsService
      .updateRetentionSettings(vm.merchantId, vm.retentionSettings)
      .then(function() {
        NotificationService.success('Retention settings successfully updated');
      })
      .catch(function() {
        NotificationService.error('Error saving retention settings. Please verify the values and try again');
      })
      .finally(disableLoading);
  }

  function enableLoading() {
    vm.isLoading = true;
  }

  function disableLoading() {
    vm.isLoading = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/retention-settings/retention-settings.controller.js